"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M16.072 6.6H10.81c-.731 0-1.327.595-1.327 1.328v1.494H8.008c-.778 0-1.408.63-1.408 1.407v5.163c0 .778.63 1.408 1.408 1.408h5.163c.777 0 1.407-.63 1.407-1.407v-1.475h1.495A1.33 1.33 0 0017.4 13.19V7.928A1.33 1.33 0 0016.072 6.6zm-.035 6.555h-5.192V7.962h5.192v5.193z" }), "Drag");
//# sourceMappingURL=Drag.js.map